<script setup>
const logoUrl = import.meta.env.VITE_LOGO_URL || new URL('@/assets/logo.svg', import.meta.url).href;
const altText = import.meta.env.VITE_APP_NAME || 'Logo';
</script>

<template>
    <div class="is-full is-flex is-justify-content-center">
        <img :src="logoUrl" :alt="altText" class="logo"/>
    </div>
</template>

<style scoped>
.logo {
    max-height: 120px;
}
</style>
